<template>
	<div id="page-login" class="container h-100 my-2 compte-creation pb-5">
		<div class="row h-100 justify-content-center align-items-center">
			<div class="col-md-10">
				<div class="text-center mb-4">
					<groomy-logo class="logo_center_bis" />
				</div>
				<div class="box box-dark">
					<div class="d-flex flex-wrap">
						<div class="col-12 col-lg-6">
							<h2>{{ $t("compte.creer_compte") }}</h2>
							<span v-if="mail" class="mb-1">{{ mail }} {{ $t('compte.mail_unknown') }}</span>
							<form @submit.prevent="validForm">
								<div class="row">
									<div class="col-6">
										<!-- Nom -->
										<div class="form-group">
											<label for="name">{{ $t('compte.nom') }}<sup>*</sup></label>
											
											<div class="input-group">
												<input autocomplete="off" class="form-control" type="text" :placeholder="$t('compte.nom')" v-model="name" id="name" required tabindex="1">
											</div>
										</div>
									</div>
									<div class="col-6">
										<!-- Prenom -->
										<div class="form-group">
											<label for="firstname">{{ $t('compte.prenom') }}<sup>*</sup></label>
											
											<div class="input-group">
												<input autocomplete="off" class="form-control" type="text" :placeholder="$t('compte.prenom')" v-model="firstname" id="firstname" required tabindex="2">
											</div>
										</div>
									</div>
									<div class="col-12">
										<div class="form-group">
											<label class="mb-0">{{ $t('compte.pays') }}*</label>
											<e-select
											track-by="id"
											label="name"
											:options="countries_iso_array"
											:searchable="true"
											:allow-empty="false"
											:show-labels="false"
											:search="true"
											:placeholder="$t('global.search_country')"
											:deselectLabel="$t('global.selected_label')"
											:selectedLabel="$t('global.press_enter_to_select')"
											:selectLabel="$t('global.search_country')"
											v-model="country"
											:tabindex="3"
											>
											<template slot="singleLabel" slot-scope="{ option }">
												<img v-if="option.iso" :src="require(`GroomyRoot/assets/img/flag-iso/${option.iso}.png`)" style="height:16px;">
												<span class="ml-2">{{ option.name }}</span>
											</template>
											<template slot="option" slot-scope="props">
												<img v-if="props.option.iso" :src="require(`GroomyRoot/assets/img/flag-iso/${props.option.iso}.png`)" style="height:16px;">
												<span class="ml-2">{{ props.option.name }}</span>
											</template>
											<template slot="noOptions">{{ $t('global.list_empty') }}</template>
										</e-select>
									</div>
								</div>
								<div class="col-12">
									<!-- Téléphone -->
									<div class="form-group phone-field">
										<label for="telephone">{{ $t('compte.telephone') }}*</label>
										
										<div class="row no-gutters">
											<div class="col-auto pr-2 phone">
												<phoneInput v-model="phone" :tabindex="-1"></phoneInput>
											</div>
											<div class="col">
												<div class="input-group">
													<div class="input-group-prepend">
														<div class="input-group-text">{{ phone.phone_indicatif }}</div>
													</div>
													<input type="text" class="form-control" v-model="phone.phone_numero" required tabindex="4">
												</div>
											</div>
										</div>
									</div>
									
									<!-- Mot de passe -->
									<div class="form-group">
										<label for="password">{{ $t('compte.password_choose') }}<sup>*</sup></label>
										
										<div class="input-group">
											<input autocomplete="off" class="form-control" :type="showPassword ? 'text' : 'password'" :placeholder="$t('compte.password')" v-model="password" id="password" required tabindex="5">
											<div class="input-group-append">
												<button type="button" class="btn btn-outline-secondary" @click="showPassword = !showPassword">
													<font-awesome-icon :icon="showPassword ? ['fal', 'eye-slash'] : ['fal', 'eye']" />
												</button>
											</div>
										</div>
									</div>
									<!-- Mot de passe confirmation -->
									<div class="form-group">
										<label for="password_confirmation">{{ $t('compte.password_confirmation') }}<sup>*</sup></label>
										
										<div class="input-group">
											<input autocomplete="off" class="form-control" :type="showPassword ? 'text' : 'password'" :placeholder="$t('compte.password_confirmation')" v-model="password_confirmation" id="password_confirmation" required tabindex="6">
											<div class="input-group-append">
												<button type="button" class="btn btn-outline-secondary" @click="showPassword = !showPassword">
													<font-awesome-icon :icon="showPassword ? ['fal', 'eye-slash'] : ['fal', 'eye']" />
												</button>
											</div>
										</div>
									</div>
									<div>
										{{ $t('compte.mdp_doit_contenir') }} :
										<ul>
											<li :class="password_lettre">{{ $t('compte.mdp_au_moins_une_lettre') }}</li>
											<li :class="password_chiffre">{{ $t('compte.mdp_au_moins_un_chiffre') }}</li>
											<li :class="password_symbole">{{ $t('compte.mdp_au_moins_symbole') }}</li>
											<li :class="password_caracteres">{{ $t('compte.mdp_plus_12_caractere') }}</li>
											<li :class="password_identiques">{{ $t('compte.mdp_identiques') }}</li>

										</ul>
									</div>
								</div>
								<div class="col-12">
									<!-- Message d'erreur si besoin -->
									<ErrorAlert v-if="message_erreur_code !== ''" :messageI18n="message_erreur_code" />
									
									<div class="d-flex">
										<router-link :to="{ name: 'Home' }" class="btn btn-link btn-block w-50 mr-2 ">{{ $t('global.annuler') }}</router-link>
										
										<!-- Bouton de validation du formulaire -->
										<button :disabled="!canSubmit || submitting" type="submit" class="btn btn-primary w-50" tabindex="7">
											<span v-if="submitting"><font-awesome-icon :icon="['fas', 'spinner']" pulse /> {{ $t('global.chargement') }}</span>
											<span v-else>{{ $t('compte.creer_compte') }}</span>
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div class="col-12 col-lg-6">
						<h2>{{ $t("compte.creant_compte") }}</h2>
						<p v-if="welcome_loaded" v-html="welcome_message || $t('compte.texte_creant_compte_info')"></p>
						<p v-else class="text-muted"><font-awesome-icon :icon="['fal', 'spinner']" pulse /></p>
						<p v-html="$t('compte.texte_creant_compte')"></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script type="text/javascript">
import Vue from 'vue'


import Config from "@/mixins/Config.js";
import User from "@/mixins/User.js";
import Tools from "@/mixins/Tools.js";
import Navigation from "@/mixins/Navigation.js";
import Tiers from "@/mixins/Tiers.js";
import router from "@/router";

import Countries from 'GroomyRoot/assets/lang/countries/countries'
import Indicatif from 'GroomyRoot/assets/lang/countries/indicatif'

export default {
	name: "CompteCreationV2",
	mixins: [Config, User, Tools, Navigation, Tiers],
	props: {
		cp: String,
	},
	data () {
		return {
			name: null,
			firstname: null,
			mail: null,
			password: null,
			password_confirmation: null,
			ad1: null,
			ad2: null,
			code_postal: null,
			ville: null,
			datenaissance: null,
			indicatifs: {},
			phone: {
				phone_indicatif: '+33',
				phone_numero: '',
				phone_country: "FRA",
				phone_country_iso2: "FR"
			},
			canSubmit: false,
			submitting: false,
			message_erreur_code: "",
			password_lettre: 'password_red',
			password_chiffre: 'password_red',
			password_symbole: 'password_red',
			password_caracteres: 'password_red',
			password_identiques: 'password_red',

			showPassword: false,
			countries: [],
			countries_iso: [],
			countries_iso_array: [],
			country: null,
			welcome_message: '',
			welcome_loaded: false,
		}
	},
	mounted() {
		this.init_component()
		this.$nextTick(() => {
			document.getElementById('name').focus()
		})
	},
	methods: {
		async init_component() {
			this.getRedirectUrl(Vue.i18n.locale()).then(res => {
				if(res.retour.welcome_message) {
					this.welcome_message = res.retour.welcome_message
				}
				this.welcome_loaded = true
			}).catch(() => {
				this.welcome_loaded = true
			})

			const actual_date = new Date()
			this.datenaissance = actual_date.toDateInputValue()
			
			this.indicatifs = Indicatif
			this.countries = Countries[Vue.i18n.locale()].label
			this.countries_iso = Countries[Vue.i18n.locale()].iso_3
			const countries_iso_2 = Countries[Vue.i18n.locale()].iso
			
			let countries_values = Object.values(this.countries)
			let countries_iso_values = Object.values(this.countries_iso)
			
			let temp = []
			for (let i = 0; i < countries_values.length; i++) {
				temp.push(countries_values[i])
			}
			
			let countries_iso_array_temp = []
			let countries_keys = Object.keys(this.countries)
			let countries_formatted = Object.fromEntries(countries_keys.map((_, i) => [countries_keys[i], temp[i]]))
			
			for (let [key, value] of Object.entries(countries_formatted)){
				countries_iso_array_temp.push({
					id: key,
					name: value,
					iso: this.countries_iso[key],
					iso_2: countries_iso_2[key]
				})
			}
			this.countries_iso_array = countries_iso_array_temp.sort((a,b) => {
				let x = this.accentsTidy(a.name.toLowerCase());
				let y = this.accentsTidy(b.name.toLowerCase());
				return x < y ? -1 : x > y ? 1 : 0;
			});
			let user_lang = Vue.i18n.locale().toUpperCase()
			if(user_lang == 'EN') {
				user_lang = 'GB'
			}
			
			this.country = countries_iso_array_temp.find(country => country.iso_2 == user_lang)
			
			if(this.$route.params.email) {
				this.mail = this.$route.params.email
			}
		},
		
		async validForm() {
			if(!this.name || !this.firstname || !this.password || !this.password_confirmation || this.password !== this.password_confirmation) {
				return false
			}
			
			this.submitting = true
			this.message_erreur_code = ''
			
			let user = {
				name: this.name,
				firstname: this.firstname,
				mail: this.mail,
				password: this.password,
				password_confirmation: this.password_confirmation,
				indicatif: this.phone.phone_indicatif,
				phone: this.phone.phone_numero,
				country: this.country ? this.country.iso_2 : null,
				phone_country: this.phone.phone_country_iso2,
			}
			
			let res = await this.createUser(user, 'client_area')
			if(res.code_retour) {
				// this.$cache.user_id = res.retour.id
				await this.setConfig("user_id", res.retour.id)
				
				const result_login = await this.checkLogin(this.mail, this.password)
				if(result_login){
					this.$router.push({ name: 'EmailValidation', params: { email: this.mail } })
				}
			}
			else {
				this.message_erreur_code = res.retour
				this.submitting = false
			}
		},
		indicatif(country)
		{
			this.phone.phone_indicatif = this.indicatifs[country]
			this.phone.phone_country = country
		},
		
		checkPassword(password) {
			this.canSubmit = true
			if (password.match(/[a-zA-Z]/)){
				this.password_lettre = 'password_green'
			} else {
				this.password_lettre = 'password_red'
				this.canSubmit = false
			}
			
			if (password.match(/\d/)){
				this.password_chiffre = 'password_green'
			} else{
				this.password_chiffre = 'password_red'
				this.canSubmit = false
			}
			
			if (password.match(/[!"#$%&'()*+,-.:;<=>?@[\]^_`{|}~]/)){
				this.password_symbole = 'password_green'
			} else{
				this.password_symbole = 'password_red'
				this.canSubmit = false
			}
			
			if (password.length >= 12){
				this.password_caracteres = 'password_green'
			} else{
				this.password_caracteres = 'password_red'
				this.canSubmit = false
			}
			if(this.password === this.password_confirmation && this.password !== '') {
				this.password_identiques = 'password_green'
			}
			else {
				this.password_identiques = 'password_red'
				this.canSubmit = false
			}
		}
	},
	watch: {
		'password' (val) {
			this.checkPassword(val)
		},
		'password_confirmation' () {
			this.checkPassword(this.password || '')
		},
		'country' (val) {
			if (val && val.iso) {
				this.phone.phone_indicatif = this.indicatifs[val.iso] || '+33'
				this.phone.phone_country = val.iso
				this.phone.phone_country_iso2 = val.iso_2
			}
		},
		'phone.phone_country' (val) {
			if (val && this.countries_iso_array.length) {
				const found = this.countries_iso_array.find(c => c.iso === val)
				if (found) {
					this.phone.phone_country_iso2 = found.iso_2
				}
			}
		}
	},
	components: {
		HeaderTab: () => import('@/components/HeaderTab'),
		ErrorAlert: () => import('GroomyRoot/components/Alert/ErrorAlert'),
		PhoneInput : () => import('GroomyRoot/components/Inputs/PhoneInput'),
	}
};
</script>
